

(function (context) {
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('lib-thirdparty/jquery.touchhooks',['require','jquery'],function(require) {
        'use strict';

        var $ = require('jquery');

        var events = ['touchstart', 'touchmove', 'touchend'];

        var fix = {
            props: 'touches changedTouches'.split(' '),
            filter: function(event, original) {
                var touch = original.changedTouches[0];

                event.pageX = touch.pageX;
                event.pageY = touch.pageY;
                event.screenX = touch.screenX;
                event.screenY = touch.screenY;
                event.clientX = touch.clientX;
                event.clientY = touch.clientY;

                return event;
            }
        };

        var i = 0;
        var length = events.length;

        for (; i < length; i++) {
            jQuery.event.fixHooks[events[i]] = fix;
        }

        return $;

    });

}(MMMRequire));
